import React from "react";
import { ReactSVG } from "react-svg";

import Tooltip from "../Chat/components/Tooltip";

import infoIcon from "icons/info-indicator.svg";

const InfoTooltip = ({ info }) => {

  return (
    <Tooltip className="info-tooltip" text={info}>
      <button>
        <ReactSVG className="icon" src={infoIcon} />
      </button>
    </Tooltip>
  );
}

export default InfoTooltip;
